import React from "react"
import { Button } from "primereact/button"
import { Dialog } from 'primereact/dialog'
import { GoAlert } from 'react-icons/go'

import './aviso.css'

export default function DialogAvisoSemReload({ openDialog, setOpenDialog, messageHeader, messageBody,confirmacaoDelete }) {
  const close = () => {
    setOpenDialog(false)
    confirmacaoDelete(false)
  }

  const aceitar = () => {
    setOpenDialog(false)
    confirmacaoDelete(true)
  }

  const footer = (
    <div>
      <Button label="Ok" icon="pi pi-thumbs-up" className="p-button-success" onClick={aceitar} />
      <Button label="Cancelar" icon="pi pi-thumbs-down" className="p-button-danger" onClick={close} />
    </div>
    
  );


  return (
    <Dialog header={messageHeader} footer={footer} visible={openDialog} style={{ width: '50vw' }} modal={true} onHide={close}>
      <div className="dialog-content">
        <GoAlert color="orange" fontSize={50} />
        <h1>{messageBody}</h1>
      </div>
    </Dialog>
  )
}